import Vue from 'vue'
import Vuex from 'vuex'
import pathify, { make } from 'vuex-pathify'
import login from '../../../coreui/store/login.js'
import mqtt from '../../../coreui/store/mqtt.js'
import cache from '../../../coreui/store/cache.js'
import log from '../../../coreui/store/log.js'
import table from '../../../coreui/store/table.js'
import misc from '../../../coreui/store/misc.js'
import dialog from '../../../coreui/store/dialog.js'
import state from './state'
Vue.use(Vuex)

export default new Vuex.Store({
  namespaced: true,
  name: "global",
  plugins: [pathify.plugin], // activate plugin
  state,
  modules: {
    login,
    mqtt,
    cache,
    log,
    table,
    misc,
    dialog
  }
});

